/* ==========================================================================
   Royal Care Professional — scroll reveal

   One IntersectionObserver for the whole page. Containers marked
   [data-rc-reveal] get an is-armed class (which is what actually hides their
   .rc-rv children in CSS), then is-in when they scroll into view; each target
   is unobserved as soon as it fires, so nothing accumulates.

   Arming in JS rather than CSS is deliberate: if this file never loads, the
   content renders visible instead of invisible.

   Idempotent, so the theme editor can re-run init() on every section load.
   ========================================================================== */

(function () {
  'use strict';

  if (window.RCReveal) {
    window.RCReveal.init();
    return;
  }

  var observer = null;

  function watcher() {
    if (observer) return observer;

    observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) return;
          entry.target.classList.add('is-in');
          observer.unobserve(entry.target);
        });
      },
      { rootMargin: '0px 0px -10% 0px', threshold: 0.12 }
    );

    return observer;
  }

  function init(scope) {
    // Without an observer nothing would ever lift the hidden state, so leave
    // the content alone and let it render as-is.
    if (!('IntersectionObserver' in window)) return;

    var root = scope || document;

    Array.prototype.forEach.call(root.querySelectorAll('[data-rc-reveal]'), function (node) {
      if (node.dataset.rcRevealInit === 'true') return;
      node.dataset.rcRevealInit = 'true';

      node.classList.add('is-armed');
      watcher().observe(node);
    });
  }

  window.RCReveal = { init: init };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init();
    });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
